export const fieldsRules = {
    requiredFields: ["name", "email"]
};
